import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';
import useCanvasId from '../../utils/useCanvasId.js';

var _excluded = ["aria-label", "aria-labelledby", "checked", "className", "data-testid", "disabled", "error", "id", "label", "name", "onChange", "required", "value"];
var SingleRadio = function SingleRadio(_ref) {
  var ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    checked = _ref.checked,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    disabled = _ref.disabled,
    error = _ref.error,
    id = _ref.id,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var uuid = useCanvasId(id, 'SingleRadio');
  if (!name || !value) {
    console.error('Hey Canvas user! Single Radio requires a name and a value.');
  }
  var radioClasses = classnames('C-InputRadio__Option__Selector', {
    isErrored: error
  });
  var labelClasses = classnames({
    isDisabled: disabled,
    isErrored: error
  });
  var optionClassName = classnames('C-InputRadio__Option', className, {
    isDisabled: disabled
  });
  var handleOnChange = function handleOnChange(value, event) {
    onChange && onChange(event);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: optionClassName
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    checked: checked,
    className: "C-InputRadio__Option__Input",
    id: id ? "".concat(id) : "".concat(uuid),
    name: name,
    "data-testid": dataTestId,
    value: value,
    type: "radio",
    required: required,
    "aria-required": required ? 'true' : 'false',
    disabled: disabled,
    onChange: function onChange(event) {
      return handleOnChange(value, event);
    }
  }, otherProps)), /*#__PURE__*/React__default.createElement("span", {
    key: id ? "".concat(id) : "".concat(uuid),
    className: radioClasses
  }), label && (required ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("label", {
    className: labelClasses,
    htmlFor: id ? "".concat(id) : "".concat(uuid)
  }, label), /*#__PURE__*/React__default.createElement("span", {
    className: "C-Input--type-label__Required"
  }, "*")) : /*#__PURE__*/React__default.createElement("label", {
    className: labelClasses,
    htmlFor: id ? "".concat(id) : "".concat(uuid)
  }, label)));
};
SingleRadio.displayName = 'Input.SingleRadio';

export { SingleRadio as default };
